export enum TABLE_SPEC_TYPE {
  MULTI_COLUMN = 'multiColumn',
  DOUBLE_ATTRS = 'doubleAttrs',
}

export interface GenericAttr {
  key: string;
  value: string;
}

export interface ProducSpecsDoubleColumn {
  uid: string;
  title: string;
  attributes: GenericAttr[];
}

export interface ProducSpecsSingleColumn {
  uid: string;
  title: string;
  attributes: {
    [key: string]: GenericAttr;
  }[];
}

export interface ProducSpecsDoubleColumnNormalized {
  uid: string;
  title: string;
  attributes: { key_01: string; value_01: string; key_02: string; value_02: string }[];
}
